import { Fragment, useCallback, useLayoutEffect } from 'react';
import { useParams, usePerformanceReportBuilderPageStore } from '@diana/core';
import { ModalHub } from './Modals/ModalHub';
import { PerformanceReportBuilderPageNavbar } from './PerformanceReportBuilderPageNavbar';
import {
  PerformanceReportBuilderPageContent,
  PerformanceReportBuilderPageContentSkeleton,
} from './PerformanceReportBuilderPageContent';
import { useGetOrCreateDraftLayoutMutation } from './Mutations/useGetOrCreateDraftLayoutMutation';
import { PerformanceReportBuilderPageContext } from './PerformanceReportBuilderPageContext';
import { PerformanceReportBuilderPageError } from './PerformanceReportBuilderPageError';
import { FlowBuilderModalContentTypeEnum } from '../FlowBuilder2Page/Store/FlowBuilder2PageStore.types';

export const PerformanceReportBuilderPage = () => {
  const { reportId: layoutId = '' } = useParams<{ reportId: string }>();

  const { mutate, isPending: isLoading, error } = useGetOrCreateDraftLayoutMutation();

  const loadLayout = useCallback(() => mutate(layoutId), [mutate, layoutId]);

  useLayoutEffect(() => {
    loadLayout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutId]);

  return (
    <PerformanceReportBuilderPageContext.Provider
      value={{ error, isLoading, reloadLayout: loadLayout }}
    >
      <ModalHub />
      <PerformanceReportBuilderPageNavbar />
      {isLoading ? (
        <PerformanceReportBuilderPageContentSkeleton />
      ) : error ? (
        <PerformanceReportBuilderPageError error={error} />
      ) : (
        <Content />
      )}
    </PerformanceReportBuilderPageContext.Provider>
  );
};

const Content = () => {
  const layout = usePerformanceReportBuilderPageStore((s) => s.layout);
  const activeModal = usePerformanceReportBuilderPageStore((s) => s.activeModal);

  if (!layout || activeModal === FlowBuilderModalContentTypeEnum.AdvancedEditor)
    return <Fragment />;
  return <PerformanceReportBuilderPageContent layout={layout} />;
};
